module.exports = __webpack_public_path__ + "PTMETTAabout-7.5803315d.png";